import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { toastConfig } from 'assets/data/config';

interface AOR {
  id: string;
  name: string;
}

interface DistributionList {
  id: string;
  name: string;
  description?: string;
  aor?: AOR | null;
  members?: Array<{
    id: string;
    name: string;
    email: string;
  }>;
  created_at: string;
  updated_at: string;
}

export const useDistributionLists = (group_guid: string | undefined) => {
  return useQuery<DistributionList[], AxiosError>({
    queryKey: ['distributionLists', group_guid],
    queryFn: async () => {
      if (!group_guid) return [];

      try {
        const response = await axios.post<DistributionList[]>(
          config.apiGateway.fetchDistributionListByGroup,
          {
            group_guid,
          }
        );
        return response.data;
      } catch (error) {
        console.error('Error fetching distribution lists:', error);
        toast.error('Failed to fetch distribution lists.', {
          ...toastConfig,
          autoClose: false,
        });
        throw error;
      }
    },
    retry: false,
  });
};
